import { Observable } from "rxjs"
import { AssignedClinic, WorkforceClinicPortal } from "../../AppState"

export interface CompaniesFilterParams {
  portal: WorkforceClinicPortal
  query: string
  locationsOnly: boolean
  accountID: number
}

export default function CompaniesGetObservable(filter: CompaniesFilterParams): Observable<AssignedClinic[]> {
  return new Observable<AssignedClinic[]>(observer => {
    if (filter.locationsOnly) {
      observer.next(filter.portal.AssignedClientDetailsOfClinic
        .filter(company => !!company.LocationName && company.AccountID === filter.accountID && company.LocationName.toLowerCase().indexOf(filter.query.toLowerCase()) !== -1)
      )
    }
    else {
      observer.next(filter.portal.AssignedClientDetailsOfClinic
        .filter(company => (company.Name.toLowerCase().indexOf(filter.query.toLowerCase()) !== -1 && company.LocationID == 0))
      )
    }
    observer.complete()
  })
}
